var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('span',{staticClass:"grey"},[_vm._v("Price:")]),_vm._v(" "),_c('b',{class:{discounted: _vm.discount}},[_vm._v(_vm._s(_vm.formattedPrice))]),_vm._v(" "),(_vm.discount)?_c('b',[_vm._v(_vm._s(_vm.discountedPrice))]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }